import NotificationsEmptyIcon from 'assets/icons/notifications_empty-2.svg';
import DropdownCommon, {
  DropdownItemStyled,
} from 'components/common/DropdownCommon';
import NotifyAnimationBlueIcon from 'components/common/Icons/NotifyAnimationBlueIcon';
import NotifyAnimationLightIcon from 'components/common/Icons/NotifyAnimationLightIcon';
import NotificationIcon from 'components/common/Icons/NotifyIcon';
import { NOTIFICATIONS_PREFIX } from 'constants';
import { datePicker } from 'helpers';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import useNotify from 'hooks/useNotify';
import useStore from 'hooks/useStore';
import useTheme from 'hooks/useTheme';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { SET_NEW_NOTIFICATION } from 'store/action';
import styled from 'styled-components';

export const NOTIFICATION_NAME = 'notification-name';

const CLASSNAME_DROPDOWN_TOGGLE = 'notification-desktop-icon';

const CustomNotificationDropdown = () => {
  const { t, locate } = useLang();
  const { state, dispatch } = useStore();
  let { isNewNotification, notifications } = state;
  const { isHHMTTheme } = useTheme();

  const [isShowDropdown, setShowDropdown] = useState(false);

  const { handleNotifyOnClick } = useNotify();

  let notificationsLimit;
  if (notifications && Array.isArray(notifications)) {
    notificationsLimit = notifications.slice(0, 5);
  }

  let notificationsUnread;
  if (notifications && Array.isArray(notifications)) {
    notificationsUnread = notifications?.filter(({ read }) => !read);
  }

  const handleDropdownOnToggle = () => {
    setShowDropdown(!isShowDropdown);

    dispatch({
      type: SET_NEW_NOTIFICATION,
      payload: false,
    });
  };
  const renderDropdownToggleChildren = () => (
    <>
      {isNewNotification ? (
        <>
          {isHHMTTheme ? (
            <NotifyAnimationLightIcon />
          ) : (
            <NotifyAnimationBlueIcon />
          )}
        </>
      ) : (
        <>
          <NotificationIcon
            color={isHHMTTheme ? 'var(--ds-c-white)' : 'var( --ds-c-black)'}
            styles={{
              padding: '9.5px',
              right: 0,
            }}
          />
        </>
      )}
      {!isEmpty(notificationsUnread) && (
        <HaveNotify>{notificationsUnread.length}</HaveNotify>
      )}
    </>
  );
  const renderDropdownMenuChildren = () => (
    <>
      {!isEmpty(notificationsLimit) ? (
        <>
          {notificationsLimit.map(
            ({ createdAt, message, read, icon }, index) => (
              <CustomDropdownItemStyled
                key={index}
                eventKey={index}
                onClick={(e) =>
                  handleNotifyOnClick(e, notificationsLimit[index])
                }
                $isRead={!read}
              >
                <Title>
                  <img src={icon} width={18} height={18} alt="" />{' '}
                  {message?.[locate?.toUpperCase()]?.title ||
                    message?.[locate]?.title}{' '}
                  {!read && <MarkUnread>●</MarkUnread>}
                </Title>
                <Desc>
                  {message?.[locate?.toUpperCase()]?.short ||
                    message?.[locate]?.short}
                </Desc>
                <DateTime>
                  {`${datePicker.convert24hhmmTo12hhmm(
                    datePicker.timeUTCToTimeStr(new Date(parseInt(createdAt))),
                  )} - ${datePicker.dateUTCToDateStr(
                    new Date(parseInt(createdAt)),
                  )}`}
                </DateTime>
              </CustomDropdownItemStyled>
            ),
          )}
          <SeeAllNotifications
            href={`${NOTIFICATIONS_PREFIX}`}
            onClick={handleNotifyOnClick}
          >
            {t('label_see_all_notifications')}
          </SeeAllNotifications>
        </>
      ) : (
        <>
          <img src={NotificationsEmptyIcon} width={200} height={200} alt="" />
          <Desc
            style={{
              margin: 0,
              color: 'var(--c-sub-info-hover)',
              textAlign: 'center',
            }}
          >
            {t('label_empty_notification')}
          </Desc>
        </>
      )}
    </>
  );

  const getStyleDropdown = () => ({
    width: '36px',
    minHeight: '36px',
    border: 'none',
    marginRight: '32px',
  });
  const getStyleDropdownToggle = () => ({
    minHeight: '36px',
    padding: 0,
    borderRadius: 0,
    svgTransformHover: 'scale(1.3)',
  });
  const getStyleDropdownMenu = () => ({
    borderRadius: '8px',
    background: '#fff',
    minWidth: '440px',
    minHeight: '300px',
    transform: 'translate(-405px, 37px)',
    padding: isEmpty(notificationsLimit) ? '40px 120px' : 0,
  });

  return (
    <CustomNotificationDropdownStyled>
      <DropdownCommon
        isShowDropdown={isShowDropdown}
        onToggle={handleDropdownOnToggle}
        renderDropdownToggleChildren={renderDropdownToggleChildren}
        renderDropdownMenuChildren={renderDropdownMenuChildren}
        styleDropdown={getStyleDropdown()}
        classNameDropdownToggle={CLASSNAME_DROPDOWN_TOGGLE}
        styleDropdownToggle={getStyleDropdownToggle()}
        styleDropdownMenu={getStyleDropdownMenu()}
      />
    </CustomNotificationDropdownStyled>
  );
};

const CustomNotificationDropdownStyled = styled.div`
  display: flex;
  align-items: center;
  ${Fade};
`;

const CustomDropdownItemStyled = styled(DropdownItemStyled)`
  background-color: ${(props) =>
    props.$isRead ? 'var(--ds-c-grey-disabled)' : 'var(--ds-c-white)'};
  border-bottom: 1px solid #d0dce5;
  text-transform: unset;

  &:hover {
    background-color: ${(props) =>
      props.$isRead ? 'var(--ds-c-grey-disabled)' : 'var(--ds-c-white)'};
  }

  &:active {
    background-color: ${(props) =>
      props.$isRead ? 'var(--ds-c-grey-disabled)' : 'var(--ds-c-white)'};
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }
`;
const Title = styled.p`
  font-family: var(--ff-primary);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: #0e1012;

  margin-bottom: 8px;
  display: flex;
  align-items: center;
  text-wrap: wrap;
  white-space: break-spaces;

  & span {
    font-family: var(--ff-secondary);
    color: var(--ds-c-blue);
    font-weight: 700;
    margin-left: 4px;
  }

  & img {
    margin-right: 8px;
  }
`;
const MarkUnread = styled.span`
  font-size: 18px;
  color: var(--ds-c-red) !important;
`;
const Desc = styled.p`
  font-family: var(--ff-primary);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: var(--ds-c-grey-dark);
  text-wrap: wrap;
  white-space: break-spaces;
  margin-bottom: 8px;
`;
const DateTime = styled.p`
  font-family: var(--ff-primary);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: var(--ds-c-grey-neutral);
  text-align: right;

  margin-bottom: 0px;
`;
const SeeAllNotifications = styled.a`
  font-family: var(--ff-primary);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--ds-c-blue);
  text-decoration: none;
  cursor: pointer;

  display: flex;
  height: 50px;
  justify-content: center;
  align-items: center;

  &:hover {
    color: var(--ds-c-blue-hover);
  }
`;

const HaveNotify = styled.span`
  font-family: var(--ff-primary);
  line-height: 1;
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  color: var(--ds-c-white);
  text-decoration: none;
  text-align: center;
  padding: 0;
  padding-top: 1px;

  position: absolute;
  top: 0px;
  left: 18px !important;
  width: 13px;
  height: 13px;
  background: var(--ds-c-red);
  border-radius: 100%;
  user-select: none;
`;

export default CustomNotificationDropdown;
